import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
    selector: "sps-advanced-search-footer",
    template: `<ng-content></ng-content>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpsAdvancedSearchFooterComponent {}
